export function normalizeString(string_: string): string {
	string_ = string_.toString().trim().toLowerCase();
	string_ = string_.normalize('NFD').replaceAll(/[\u0300-\u036F]/g, '');
	string_ = string_.replaceAll(' ', '_');
	return string_;
}
